import { createTheme } from '@mui/material/styles'
import { surfaceAuthCanvas, surfaceAuthCard } from './designTokens'
import { componentOverrides } from './components'

export const theme = createTheme({
  palette: {
    primary: { main: '#008CD0', dark: '#0077B3', light: '#4DB8E8' },
    secondary: { main: '#7b1fa2' },
    background: {
      /** Figma auth canvas — must match CssBaseline body (ld-101) */
      default: surfaceAuthCanvas,
      paper: surfaceAuthCard,
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  shape: { borderRadius: 8 },
  components: componentOverrides,
})
